
































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import IProjectOutput from "@/api/models/IProjectOutput";
import IOrderOutput from "@/api/models/IOrderOutput";
import { Company, Office } from "@/api/company-api";
import VDelete from "../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import ProjectPropertiesForm from "@/components/project/property/ProjectPropertiesForm.vue";
import ProjectTaskDefaultsForm from "@/components/project/property/ProjectTaskDefaultsForm.vue";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import Decimal from "decimal.js";
import emitter from "@/EventBus";
import { ProjectPropertyKey } from "@/api/project/project-properties-api";
import { isNewProject } from "@/preferences";

@Component({
  components: {
    ProjectPropertiesForm,
    ProjectTaskDefaultsForm,
    VDelete,
    SwitchButton
  },
  methods: {
    isNewProject
  }
})
export default class ProjectEdit extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) project!: IProjectOutput;
  @Prop({ required: true }) order!: IOrderOutput;
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  @Prop({ default: () => [] }) clientOptions!: SelectOption[];
  @Prop({ default: () => [] }) clientStaffOptions!: SelectOption[];
  @Prop({ default: () => [] }) templateOptions!: SelectOption[];

  status = "";
  error: string = "";
  contractDate = this.project.contractDate;
  defaultKey: ProjectPropertyKey[] = [];
  get service() {
    return this.$store.state.service;
  }

  checkClient(checkBoxStatus: any) {
    if (checkBoxStatus) {
      this.company.client = false;
    } else {
      this.company.client = true;
    }
  }

  get profitRate(): string {
    if (this.office.profitRate === null) {
      return "";
    }
    return String(new Decimal(this.office.profitRate).mul(100));
  }

  set profitRate(profitRate: string) {
    if (!profitRate) {
      this.office.profitRate = null;
      return;
    }
    this.office.profitRate = new Decimal(profitRate).div(100).toNumber();
  }

  ok() {
    if (
      this.project.templateId &&
      !confirm("工程表のテンプレートを反映してもよろしいですか？")
    ) {
      return;
    }
    this.status = "progressing";
    this.$emit("ok");
    emitter.on("message", (e: any) => {
      this.status = "";
      this.error = e[0];
    });
  }

  get isRequired(): boolean {
    if (this.contractDate && this.contractDate !== "0000-00-00") {
      return true;
    }

    return false;
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }

  beforeDestroy() {
    emitter.off("message");
  }
}
